import React, {PropsWithChildren} from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";

export default function DataRow({
  label,
  children,
  vertical = false,
  labelSize = 3,
  className = undefined,
}: PropsWithChildren<{
  label: React.ReactNode;
  className?: string;
  vertical?: boolean;
  labelSize?: number;
}>) {
    if (vertical) {
        return (
            <div className="mb-3">
                <FormCheckLabel className="text-sm">{label}</FormCheckLabel>
                <div className={className}>{children || '-'}</div>
            </div>
        )
    }
    return (
        <Row className="py-2">
            <Col sm={labelSize} className="fw-semibold">{label}</Col>
            <Col sm={12 - labelSize} className={className}>{children || '-'}</Col>
        </Row>
    );
}

